// Feature flag bypass token (?bypass_token=<secret>) is captured once on app load
// and kept in module memory (never in storage). In production the inline <head>
// script in index.html strips it from the URL first and hands it over in the
// window global named below; this helper reads that global once and deletes it.
// The URL branch is a fallback for when the inline script did not run.

// Must match the property name in the inline script of src/index.html
// (a spec guards that both files use the same name).
export const BYPASS_TOKEN_WINDOW_KEY = '_featureFlagBypassToken';

let capturedToken: string | null = null;

export function captureFeatureFlagBypassToken(search: string = window.location.search): void {
  // Read the window global handed over by the inline script, then delete it
  // unconditionally so third-party scripts cannot read it from window.
  const holder = window as any;
  const windowToken = holder[BYPASS_TOKEN_WINDOW_KEY];
  delete holder[BYPASS_TOKEN_WINDOW_KEY];

  const query = new URLSearchParams(search);
  const token = query.get('bypass_token');

  if (token) {
    capturedToken = token;
    // Strip the bypass_token parameter from the URL only when captured from the live URL.
    // If called from tests with a different search string, do not rewrite window.location.
    if (search === window.location.search) {
      // Collapse a leading '//' so the path cannot be read as another origin.
      const pathname = window.location.pathname.replace(/^\/+/, '/');
      const hash = window.location.hash;

      // Remove bypass_token from the query params
      query.delete('bypass_token');
      const remainingSearch = query.toString() ? `?${query.toString()}` : '';

      try {
        history.replaceState(history.state, '', pathname + remainingSearch + hash);
      } catch (e) {
        // Never let a URL rewrite failure abort the app bootstrap.
      }
    }
  } else if (windowToken) {
    capturedToken = windowToken;
  }
}

export function getFeatureFlagBypassToken(): string | null {
  return capturedToken;
}

// Test-only reset of the module state.
export function resetFeatureFlagBypassToken(): void {
  capturedToken = null;
}
